/**
 * created by li si yi
 *
 */
import React, {Component} from 'react';
import {Tabs, Button, Input, Table, Pagination, Popover} from "antd";
import './MyTable.css'
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import PropTypes from "prop-types";
import {HEADER_HEIGHT} from "../../../constants";
import BaseTable from "../../components/baseTable/BaseTable";
import BaseComponent from "../../../base/BaseComponent";
import $Jq from "jquery";

const {TabPane} = Tabs;
const {Search} = Input;

export default class MyTable extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    render() {
        return (
            <div className={'NewsContributeBox'}>
                {this.renderTab()}
                {this.renderSearch()}
                {this.renderTable()}
                {this.renderPagination()}
            </div>
        )
    }

    //选项卡
    renderTab = () => {
        let {tabList, changeTabBar, activeKey} = this.props;
        return (
            <Tabs activeKey={activeKey} onChange={changeTabBar} style={{paddingTop: 10}}>
                {tabList.map((item, index) => {
                    // console.log(item.key)
                    return (
                        <TabPane tab={item.key} key={item.key}/>
                    )
                })}
            </Tabs>
        )
    };

    addStory = () => {
        const targetWindow = window.openEditById({configName:"storyEditor",id:0,params: (this.props.editorParams || {})});
    };

    //写稿、搜索
    renderSearch = () => {
        let {onSearch, onChange,params} = this.props;
        return (
            <div className={'searchBox'}>
                {
                    this.permissionCheck('contribute_power') && <Button type="primary" onClick={this.addStory}>写稿</Button>
                }
                <Search
                    placeholder="请输入稿件名称、创建人"
                    value={params.keywords}
                    onChange={(e)=>{onChange('onChange',e)}}
                    onSearch={(e)=>{onChange('onSearch',e)}}
                    className={'searchFrame'}
                    red={'box'}
                />
            </div>
        )
    };

    //表格
    renderTable = () => {
        let {tableHeight, data, columns} = this.props;
        let {dataSource} = data;
        let height = window.innerHeight - HEADER_HEIGHT;
        tableHeight = height - 82 - 54 - 81 - 15 - 15;
        return (
            <div style={{maxHeight: tableHeight,padding: '0 30px'}}>
                <Scrollbars autoHeight autoHeightMax={tableHeight}>
                    <BaseTable
                        columns={columns} dataSource={dataSource}
                    />
                </Scrollbars>
            </div>
        )
    };

    // 分页
    renderPagination = () => {
        let {data, params,onChange} = this.props;
        let {size, page} = params;
        let {total} = data;
        let {dataSource} = data;
        if(!total) return <div style={{height:81}}></div>;
        if(!(dataSource&&dataSource.length>0) && page>1) {
            onChange('page',--page);
        }
        return (
            <div className={'pagination'}>
                <div style={{padding:"0 10px 0"}}>共{total}条数据</div>
                <Pagination
                    showSizeChanger
                    current={page}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={(page, size) => onChange('page', page)}
                    onShowSizeChange={(page, size) => onChange('size', size)}
                />
            </div>
        )
    }
}
MyTable.defaultProps = {
    columns: [],
    dataSource: [],
    tableHeight: 770,
};
MyTable.propTypes = {
    /**
     * @text 表格高度
     * @category number
     */
    tableHeight: PropTypes.number,
    /**
     * @text 搜索(是否展示搜索框)
     * @category number
     */
    mySearch: PropTypes.func,
    /**
     * @text 表格表头
     * @category array
     */
    columns: PropTypes.array.isRequired,
    /**
     * @text 表格数据
     * @category array
     */
    dataSource: PropTypes.array.isRequired,
    /**
     * @text 选项卡数据改变
     * @category func
     */
    changeTabBar: PropTypes.func,
};